module.exports = __webpack_public_path__ + "img/users_red.ae8f010c.svg";